module.exports = __webpack_public_path__ + "img/old_logo_1024.df20cea6.df20cea6.png";